/**
 * Hook registry — merges colocated hooks from Phoenix with manually defined hooks.
 * Each hook is in its own file for maintainability.
 */
import {hooks as colocatedHooks} from "phoenix-colocated/trade_machine"

import AnalyticsHook from "./analytics-hook"
import CopyToClipboard from "./copy-to-clipboard"
import FocusOnMount from "./focus-on-mount"
import SalaryInput from "./salary-input"
import ScenarioPersistence from "./scenario-persistence"
import GlossaryTip from "./glossary-tip"
import SalaryTip from "./salary-tip"
import CapLineTip from "./cap-line-tip"
import EpmToggle from "./epm-toggle"
import SortableTable from "./sortable-table"
import CompBrowser from "./comp-browser"
import ScrollToBottom from "./scroll-to-bottom"
import CapsheetTour from "./capsheet-tour"
import FeatureTutorial from "./feature-tutorial"
import PasteUpload from "./paste-upload"
import KanbanBoard from "./kanban-board"
import DepthChartDrag from "./depth-chart-drag"
import DropdownPosition from "./dropdown-position"
import FeedbackFab from "./feedback-fab"
import AutoDismissFlash from "./auto-dismiss-flash"
import CommandPalette from "./command-palette"
import Sheet from "./sheet"
import PopTip from "./pop-tip"
import TableScroll from "./table-scroll"
import PayrollSeasons from "./payroll-seasons"
import TeamPicker from "./team-picker"

export default {
  ...colocatedHooks,
  AnalyticsHook,
  CopyToClipboard,
  FocusOnMount,
  SalaryInput,
  ScenarioPersistence,
  GlossaryTip,
  SalaryTip,
  CapLineTip,
  EpmToggle,
  SortableTable,
  CompBrowser,
  ScrollToBottom,
  CapsheetTour,
  FeatureTutorial,
  PasteUpload,
  KanbanBoard,
  DepthChartDrag,
  DropdownPosition,
  FeedbackFab,
  AutoDismissFlash,
  CommandPalette,
  Sheet,
  PopTip,
  TableScroll,
  PayrollSeasons,
  TeamPicker,
}
